var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"modal-wrap"},[_vm._t("default"),_vm._v(" "),(_vm.showBg)?_c('div',{staticClass:"modal-bg",style:({
      'background-color': ("rgba(0, 0, 0, " + _vm.opacity + ")")
    }),on:{"click":_vm.handleClick}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }